import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { IconButton, CircularProgress, Autocomplete, TextField, Tabs, Tab } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';

function ViewArticle() {
    const location = useLocation();

    const navigate = useNavigate();

    const { url } = location.state || {};

    return (
        <div
            className='All-products-section-main'
            style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>

            <nav
                className='flex flex-row p-2 items-center justify-between'
                style={{
                    height: '4rem',
                    zIndex: 10,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                }}
            >
                <div className='flex flex-row items-center'>
                    <IconButton onClick={() => navigate(-1)}>
                        <ChevronLeft />
                    </IconButton>
                    <p className='mb-0'>Articles</p>
                </div>
            </nav>

            <iframe
                src={url}
                width="100%"
                height="100%"
                title="Article"
                style={{
                    border: 'none',
                    display: 'block',
                    marginTop: '4rem',
                    height: 'calc(100vh - 4rem)',
                }}
            />
            
        </div>

    )
}

export default ViewArticle